// extracted by mini-css-extract-plugin
export default {"info-box":"Home_info-box__cknWS","card":"Home_card__OP979","card1":"Home_card1__4+Pm9","card2":"Home_card2__X06ln","card3":"Home_card3__rY5VT"};